import {
  Storefront,
  PhoneOutlined,
  Place,
  Schedule,
  CreditCard,
  NoMealsOutlined,
} from "@mui/icons-material";
import { Box, Typography, Grid } from "@mui/material";
import { selectStoreDetail } from "features/searchStore/saga/searchStoreSlice";
import { useAppSelector } from "redux/hooks";

export function StoreDetailInfoSection() {
  const storeData = useAppSelector(selectStoreDetail);

  return (
    <Box display="flex" width="100%" justifyContent="center">
      <Box display="flex" flexDirection="column" width='1000px' p={5}>
        <Typography fontWeight="bold">店舗情報</Typography>

        <Box display="flex" width="100%" py={3}>
          <Storefront sx={{ p: 1 }} />
          <Box display="flex" flexDirection="column" width="100%">
            <Grid container display="flex" flex={1} my={1}>
              <Grid item xs={4}>
                <Typography fontWeight="bold" sx={{ px: 2 }}>
                  店舗情報
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography display="flex" flex={1}>
                  {storeData.Name}
                </Typography>
              </Grid>
            </Grid>

            <Grid container display="flex" flex={1} my={1}>
              <Box display="flex" flex={1}>
                <Grid item xs={4}>
                  <Typography fontWeight="bold" sx={{ px: 2 }}>
                    ジャンル
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography display="flex" flex={1}>
                    {storeData.Genres.join(", ")}
                  </Typography>
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Box>

        <Box
          display="flex"
          width="100%"
          py={3}
          sx={{ borderTopStyle: "dashed" }}
        >
          <PhoneOutlined sx={{ p: 1 }} />
          <Box display="flex" flexDirection="column" width="100%">
            <Grid container display="flex" flex={1} my={1}>
              <Grid item xs={4}>
                <Typography fontWeight="bold" sx={{ px: 2 }}>
                  予約専用
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography display="flex" flex={1}>
                  050-5232-9449
                </Typography>
              </Grid>
            </Grid>

            <Grid container display="flex" flex={1} my={1}>
              <Box display="flex" flex={1}>
                <Grid item xs={4}>
                  <Typography fontWeight="bold" sx={{ px: 2 }}>
                    お問い合わせ
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography display="flex" flex={1}>
                    03-5422-7358
                  </Typography>
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Box>

        <Box
          display="flex"
          width="100%"
          py={3}
          sx={{ borderTopStyle: "dashed" }}
        >
          <Place sx={{ p: 1 }} />
          <Box display="flex" flexDirection="column" width="100%">
            <Grid container display="flex" flex={1} my={1}>
              <Grid item xs={4}>
                <Typography fontWeight="bold" sx={{ px: 2 }}>
                  住所
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography display="flex" flex={1}>
                  東京都港区白金台5-17-10
                </Typography>
              </Grid>
            </Grid>

            <Grid container display="flex" flex={1} my={1}>
              <Box display="flex" flex={1}>
                <Grid item xs={4}>
                  <Typography fontWeight="bold" sx={{ px: 2 }}>
                    最寄り駅
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography display="flex" flex={1}>
                    都営地下鉄三田線　白金台駅
                  </Typography>
                  <Typography display="flex" flex={1}>
                    東京メトロ南北線　白金台駅
                  </Typography>
                  <Typography display="flex" flex={1}>
                    JR山手線　目黒駅
                  </Typography>
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Box>

        <Box
          display="flex"
          width="100%"
          py={3}
          sx={{ borderTopStyle: "dashed" }}
        >
          <Schedule sx={{ p: 1 }} />
          <Box display="flex" flexDirection="column" width="100%">
            <Grid container display="flex" flex={1} my={1}>
              <Grid item xs={4}>
                <Typography fontWeight="bold" sx={{ px: 2 }}>
                  営業時間
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography display="flex" flex={1}>
                  昼 12:00 ～ 15:00（12:15）
                </Typography>
                <Typography display="flex" flex={1}>
                  夜 18:00 ～ 22:30（19:30）
                </Typography>
              </Grid>
            </Grid>

            <Grid container display="flex" flex={1} my={1}>
              <Box display="flex" flex={1}>
                <Grid item xs={4}>
                  <Typography fontWeight="bold" sx={{ px: 2 }}>
                    定休日
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography display="flex" flex={1}>
                    なし（但しビル休館日は除く、年数回、不定期）
                  </Typography>
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Box>

        <Box
          display="flex"
          width="100%"
          py={3}
          sx={{ borderTopStyle: "dashed" }}
        >
          <CreditCard sx={{ p: 1 }} />
          <Box display="flex" flexDirection="column" width="100%">
            <Grid container display="flex" flex={1} my={1}>
              <Grid item xs={4}>
                <Typography fontWeight="bold" sx={{ px: 2 }}>
                  お支払い
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography display="flex" flex={1}>
                  サービス料金 10％
                </Typography>
                <Typography display="flex" flex={1}>
                  チャージ料金 ディナータイムのみお一人様550円（Salvatore Cuomo
                  Bros.） 会計方法 テーブル
                </Typography>
                <Typography display="flex" flex={1}>
                  VISA / Master / JCB / Amex / Diners / DC / UC / UFJ / NICOS /
                  SAISON / 銀聯
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box
          display="flex"
          width="100%"
          py={3}
          sx={{ borderTopStyle: "dashed" }}
        >
          <NoMealsOutlined sx={{ p: 1 }} />
          <Box display="flex" flexDirection="column" width="100%">
            <Grid container display="flex" flex={1} my={1}>
              <Grid item xs={4}>
                <Typography fontWeight="bold" sx={{ px: 2 }}>
                  キャンセル料
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography display="flex" flex={1}>
                  キャンセル料につきまして以下の通り申し受けます。
                </Typography>
                <Typography display="flex" flex={1}>
                  当日連絡なし 100%
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
